// extracted by mini-css-extract-plugin
export default {"wrapper":"WaterDetailedInfo_wrapper__g-2-n"};